import { useTranslation } from 'react-i18next'

import { InstructionTemplates } from './InstructionTemplates'

export interface AgentPersonaFieldsProps {
  readonly name: string
  readonly description: string
  readonly systemPrompt: string
  /** Nome da organização, usado nos modelos de instruções. */
  readonly companyName?: string | undefined
  readonly disabled?: boolean
  readonly onName: (value: string) => void
  readonly onDescription: (value: string) => void
  readonly onSystemPrompt: (value: string) => void
}

const INPUT =
  'rounded-md border border-border-default bg-background-default px-3 py-2 text-sm text-foreground-primary outline-none focus:border-action-primary'

/** Campos da persona do agente (nome, descrição, instruções), compartilhados entre criar e editar. */
export function AgentPersonaFields({
  name,
  description,
  systemPrompt,
  companyName,
  disabled = false,
  onName,
  onDescription,
  onSystemPrompt,
}: AgentPersonaFieldsProps) {
  const { t } = useTranslation()

  return (
    <div className="flex flex-col gap-3">
      <label className="flex flex-col gap-1.5">
        <span className="text-xs font-medium text-foreground-secondary">
          {t('agents.persona.nameLabel')}
        </span>
        <input
          value={name}
          disabled={disabled}
          maxLength={120}
          onChange={(event) => {
            onName(event.target.value)
          }}
          placeholder={t('agents.persona.namePlaceholder')}
          className={INPUT}
        />
      </label>
      <label className="flex flex-col gap-1.5">
        <span className="text-xs font-medium text-foreground-secondary">
          {t('agents.persona.descriptionLabel')}
        </span>
        <input
          value={description}
          disabled={disabled}
          maxLength={500}
          onChange={(event) => {
            onDescription(event.target.value)
          }}
          placeholder={t('agents.persona.descriptionPlaceholder')}
          className={INPUT}
        />
      </label>
      <InstructionTemplates
        current={systemPrompt}
        companyName={companyName}
        disabled={disabled}
        onApply={onSystemPrompt}
      />
      <label className="flex flex-col gap-1.5">
        <span className="text-xs font-medium text-foreground-secondary">
          {t('agents.persona.systemPromptLabel')}
        </span>
        <textarea
          value={systemPrompt}
          disabled={disabled}
          maxLength={8000}
          rows={8}
          onChange={(event) => {
            onSystemPrompt(event.target.value)
          }}
          placeholder={t('agents.persona.systemPromptPlaceholder')}
          className={INPUT}
        />
        <span className="text-xs text-foreground-muted">
          {t('agents.persona.systemPromptHint')}
        </span>
      </label>
    </div>
  )
}
